<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <app-month-picker
      label="Miesiąc rozliczeniowy" [required]="true"
      [control]="monthControl" fxFlex="100"
    ></app-month-picker>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wygeneruj</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
